<template>
<div >
    <div class="filters">
        <div class="filter">
            <el-radio v-model="radioCurrent" :label="index" v-for="(item, index) in filtersItems" :key="index">{{item.name}}</el-radio>
        </div>
        <tags-input v-model='items' class="common-tags" :message="$t('language.inputTab.filterMessage')" :type="'filter'" />
    </div>
</div>
</template>

<script>
import tagsInput from '@/components/common/input/tag_input_common';
export default {
    components: {
        tagsInput
    },
    data: function () {
        return {
            filtersItems: [{
                    name: this.$t('language.popup.ignoreFiles')
                },
                {
                    name: this.$t('language.popup.includeFiles')
                }
            ],
            radioCurrent: 0,
            items: [],
        };
    },
    watch: {
        radioCurrent(val){
            if (val == 0) {
                this.$parent.$parent.$parent.options.pattern = Object.assign('exclude');
            } else {
                this.$parent.$parent.$parent.options.pattern = Object.assign('include');
            }  
        }
    },
    methods: {
    },
};
</script>

<style lang='less' scoped>
.common-tags {
    width: 100%;
    height: 180px;/*no*/
    border: 1px solid #DCE4F5;/*no*/
}

.filters {
    .filter {
        display: flex;
        width: 100%;
        height: 20px;/*no*/
        margin-bottom: 10px;/*no*/
        /deep/ .el-radio {
            margin-right: 25px;
            /*no*/
        }
        /deep/ .el-radio__input {
            &.is-checked {
                +.el-radio__label {
                    color: #000000;
                }
                .el-radio__inner {
                    border-color: #4181FF;
                    background: #ffffff;
                    &::after {
                        transform: translate(-50%,-50%) scale(2.5);
                    }
                }
            }
            .el-radio__inner { 
                width: 16px;/*no*/
                height: 16px;/*no*/
                &::after {
                    background: #4181FF;
                }
            }
        }
        /deep/ .el-radio__label {
            color:  #6F6F6F;
            font-size: 14px;/*no*/
            font-weight: normal;
            line-height: 18px;/*no*/
            letter-spacing: 0em;
            padding-left: 5px;/*no*/
            min-width: 165px;/*no*/
        }
    }
}

.red-cancel {
    position: absolute;
    top: -6px;
    /*no*/
    right:-4Px;
    cursor: pointer;
}

.clean-list {
    float: right;
}

.eg-text {
    margin: 10px 0px 0px 10px;
    /*no*/
}

.clean-list:hover:after {
    content: attr(data-title);
    position: relative;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 200;
    width: 60px;
    /*no*/
    left: -55Px;
    top: 25Px;
    white-space: nowrap;
}

.red-back {
    background: #ff7b7b !important;
}

.green-back {
    background: #5acc9b !important;
}

.black-back {
    background: #778c9b !important;
}

.grey-back {
    background: #92a3af !important;
}

.extens {
    float: left;
    margin: 10px 0px 0px 10px;
    /*no*/
    background: #92a3af;
    font-size: 14px;
    /*no*/
    color: #fff;
    background: #5ec9ff;
    line-height: 20px;
    /*no*/
    padding: 1px 10px 1px 10px;
    /*no*/
    border-radius: 2px;
    /*no*/
    position: relative;
    max-width: 96%;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    word-wrap: break-word;
}

.slide-enter-active {
    transition: all 0.3s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.slide-leave-active {
    transition: all 0s ease;
    height: 0px;
    /*no*/
    overflow: hidden;
}

.slide-enter,
.slide-leave {
    height: 0;
    opacity: 0;
}

.ignore-boxs {
    margin-bottom: 30px;
    /*no*/
}

.add-ignores {
    margin-left: 5px;
    /*no*/
}

.ignore-input {
    width: 220px;
    /*no*/
    white-space: pre !important;
}

.ignore-files {
    width: 648px;
    /*no*/
    height: 110px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    box-sizing: border-box;
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/
.ignore-files::-webkit-scrollbar {
    width: 5px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

.ignore-files::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_filter.vue